import { SyndicatedOptions, BrandSyndicatedOptions } from './syndicated-options.interface';

const cachedPath = '/cached/';
const defaultLocale = 'en_US';
const defaultLanguage = 'en-us';
const dlrDefaultAffiliation = 'STD_GST-CAL_RESIDENT-SOCAL_RESIDENT';
const dlrSiteId = 'dlr';
const footerContent = 'legal';

const dlrHeaderDefaultOptions: SyndicatedOptions = {
  container: 'headerWrapper',
  showSignInSignOut: 1,
  languageSelector: 1,
  hideNavigation: 1,
  responsive: 1,
  affiliation: dlrDefaultAffiliation,
  locale: defaultLocale,
  language: defaultLanguage,
  siteOverride: dlrSiteId
};

const dlrFooterDefaultOptions: SyndicatedOptions = {
  container: 'footerWrapper',
  responsive: 1,
  affiliation: dlrDefaultAffiliation,
  locale: defaultLocale,
  language: defaultLanguage,
  siteOverride: dlrSiteId,
  content: footerContent
};

const brandHeaderDefaultOptions: BrandSyndicatedOptions = {
  dlr: dlrHeaderDefaultOptions
};

const brandFooterDefaultOptions: BrandSyndicatedOptions = {
  dlr: dlrFooterDefaultOptions
};

export { brandHeaderDefaultOptions, brandFooterDefaultOptions, cachedPath };
